import { NgModule } from "@angular/core";
import { AlphabetOnlyDirective } from "./alphabet-only.directive";
import { NumberDirective } from "./number-only.directive";

@NgModule({
    declarations: [NumberDirective,AlphabetOnlyDirective],
    exports: [NumberDirective,AlphabetOnlyDirective]    
  })
  export class GlobalDirectiveModule { }